import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { StylesStorage } from '../hooks/useNavigationCapabilities/styles-storage';
export const globalStylesAdapter = createEntityAdapter({
  selectId: ({
    selector
  }) => selector
});
export const globalStylesSliceName = 'globalStyles';
export const globalStylesSlice = createSlice({
  name: globalStylesSliceName,
  initialState: () => {
    const emptyState = globalStylesAdapter.getInitialState();
    const persistedStyles = StylesStorage.getInstance('indefinite');
    const persistedSessionStyles = StylesStorage.getInstance('session');
    const withLocalStorage = globalStylesAdapter.upsertMany(emptyState, Object.values(persistedStyles.read()));
    const withLocalAndSessionStorage = globalStylesAdapter.upsertMany(withLocalStorage, Object.values(persistedSessionStyles.read()));
    return withLocalAndSessionStorage;
  },
  reducers: {
    upsertStylesheet: globalStylesAdapter.upsertOne,
    deleteStylesheet: (state, {
      payload: {
        by,
        value
      }
    }) => {
      switch (by) {
        case 'selector':
          return globalStylesAdapter.removeOne(state, value);
        case 'persistenceId':
          {
            const stylesheetByPersistenceId = globalStylesAdapter.getSelectors().selectAll(state).find(stylesheet => {
              var _stylesheet$persist;
              return ((_stylesheet$persist = stylesheet.persist) === null || _stylesheet$persist === void 0 ? void 0 : _stylesheet$persist.id) === value;
            });
            if (!stylesheetByPersistenceId) {
              return state;
            }
            const id = globalStylesAdapter.selectId(stylesheetByPersistenceId);
            return globalStylesAdapter.removeOne(state, id);
          }
        default:
          return state;
      }
    }
  }
});
export const {
  reducer: globalStylesReducer,
  actions: globalStylesActions
} = globalStylesSlice;